(function () {
    angular.module('tmx-app').factory('GuarantorSummaryService', ['$http', 'APP_CONSTANTS', 'tmxResource', '$filter', '$q', 'tmxUtility', '$mdMedia', 'lookupService',
        function ($http, APP_CONSTANTS, tmxResource, $filter, $q, tmxUtility, $mdMedia, lookupService) {

            var Report = tmxResource("report");
            // Report.GetProductSkuByWarehouse = GetProductSkuByWarehouse;
            // Report.GetProductSkuByWarehouseId = GetProductSkuByWarehouseId;
            // Report.setLookups = setLookups;
            Report.exportGuarantorSummary = exportGuarantorSummary;

            // Report.Check=function(data){
            //     console.log(data.data[0]);
                
            //     if(data.data[0] && data.data[0].Guarantor1){
            //         console.log(data.data[0].Guarantor1);
            //     }
            // };

            // function exportCreditSummary(loanapplicationnumber,branchid,nationalid) {
            function exportGuarantorSummary(loanapplicationnumber,culture) {
                if(!loanapplicationnumber){
                    loanapplicationnumber=null;
                }

                if(!culture){
                    culture=null;
                }

                // if(!branchid){
                //     branchid=null;
                // }
                
                // if(!nationalid){
                //     nationalid=null;
                // }

                var objArgs = {
                    "LoanApplicationNumber":loanapplicationnumber,
                    "culture":culture
                    // "BranchId":branchid,
                    // "NationalId":nationalid
                };
      
                var filters = {
                    "StoredProcedure": "sp_guarantor_summary",
                    "Arguments": objArgs,
                    "ReportName": "Guarantor_Summary",
                    "PageOrientation": "Landscape"
                };

                //var url = '/ExportLoanReport/' + userid + '/'+ deliveryManId + '/' + startdate + '/' + enddate + '/' + new Date().getTimezoneOffset();
                $http.post(APP_CONSTANTS.backend + 'report/ReportPDF' , filters , { responseType: 'arraybuffer' })
                    .success(function (data) {
                        var file = new Blob([data], { type: 'application/pdf' });
                        saveAs(file, 'GuarantorSummary.pdf');
                    });
            }

            Report.GridColumns = [


                {
                    field: "FieldName",
                    title: "FieldName",
                    type: "text",
                        //  width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template:"{{GuarantorSummaryCtrl.formatlabel(dataItem[GuarantorSummaryCtrl.formatColumnName('FieldName')]) }}",
                    headerTemplate: "<span> {{'FieldName'|translate}} </span>"
                },
                {
                    field: "Guarantor1",
                    title: "Guarantor1",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[GuarantorSummaryCtrl.formatColumnName('Guarantor1')]}}</span>",
                    headerTemplate: "<span> {{'Guarantor1'|translate}} </span>"
                },
                {
                    field: "Guarantor2",
                    title: "Guarantor2",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[GuarantorSummaryCtrl.formatColumnName('Guarantor2')]}}</span>",
                    headerTemplate: "<span> Guarantor 2</span>"
                },
                {
                    field: "Guarantor3",
                    title: "Guarantor3",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[GuarantorSummaryCtrl.formatColumnName('Guarantor3')]}}</span>",
                    headerTemplate: "<span> Guarantor 3</span>"
                },
                {
                    field: "Guarantor4",
                    title: "Guarantor4",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[GuarantorSummaryCtrl.formatColumnName('Guarantor4')]}}</span>",
                    headerTemplate: "<span> Guarantor 4</span>"
                },
                {
                    field: "Guarantor5",
                    title: "Guarantor5",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[GuarantorSummaryCtrl.formatColumnName('Guarantor5')]}}</span>",
                    headerTemplate: "<span> Guarantor 5</span>"
                },
                {
                    field: "Guarantor6",
                    title: "Guarantor6",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[GuarantorSummaryCtrl.formatColumnName('Guarantor6')]}}</span>",
                    headerTemplate: "<span> Guarantor 6</span>"
                },
                {
                    field: "Guarantor7",
                    title: "Guarantor7",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[GuarantorSummaryCtrl.formatColumnName('Guarantor7')]}}</span>",
                    headerTemplate: "<span> Guarantor 7</span>"
                },
                {
                    field: "Guarantor8",
                    title: "Guarantor8",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[GuarantorSummaryCtrl.formatColumnName('Guarantor8')]}}</span>",
                    headerTemplate: "<span> Guarantor 8</span>"
                },
                {
                    field: "Guarantor9",
                    title: "Guarantor9",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[GuarantorSummaryCtrl.formatColumnName('Guarantor9')]}}</span>",
                    headerTemplate: "<span> Guarantor 9</span>"
                },
                {
                    field: "Guarantor10",
                    title: "Guarantor10",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[GuarantorSummaryCtrl.formatColumnName('Guarantor10')]}}</span>",
                    headerTemplate: "<span> Guarantor 10</span>"
                }
            ];


            return Report;

        }]);
})();